export function setCaretPosition(node, position) {
    if (!node)
        return;
    if (node?.childNodes[0]) {
        const range = document.createRange();
        const selection = window.getSelection();
        let textNode = node?.childNodes[node?.childNodes.length - 1];
        const textLength = textNode?.textContent?.length;
        let carretPosition = textLength;
        if (typeof position === "number") {
            const childNodes = node.childNodes;
            for (let index = 0; index < childNodes.length; index++) {
                const child = childNodes[index];
                const length = child.textContent.length;
                if (length >= position) {
                    carretPosition = position;
                    textNode = child;
                    break;
                }
                else {
                    position -= length;
                }
            }
        }
        range.setStart(textNode, carretPosition);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
    }
    setTimeout(() => node.focus());
}
export function setNodeRange(node) {
    if (!node)
        return;
    const range = document.createRange();
    const selection = window.getSelection();
    range.setStart(node, 0);
    range.setEnd(node, node?.childNodes?.length || 0);
    selection.removeAllRanges();
    selection.addRange(range);
}
export function getRangeText() {
    return window.getSelection().toString();
}
export function getCaretPosition(node) {
    const selection = window.getSelection();
    const range = document.createRange();
    range.setStart(node, 0);
    range.setEnd(selection.anchorNode, selection.anchorOffset);
    return range.toString().length;
}
export function getCaretCoords() {
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
    const rect = range.getBoundingClientRect();
    return { x: rect.x, y: rect.y };
}
//# sourceMappingURL=carret.js.map